import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import 'react';
import { useDropdownContext } from '../../Dropdown/DropdownProvider.js';
import '../../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import '@xstate/react';
import '../../Dropdown/dropdownMachine.js';
import { DropdownButton } from '../../Dropdown/DropdownButton.js';
import 'react-focus-lock';
import '@reach/rect';
import '../../Box/index.js';
import '../../Popover/Popover.js';
import 'tabbable';
import '@reach/utils';
import '../../IconButton/IconButton.js';
import { useSelectableContext } from '../../Selectable/SelectableProvider.js';

var MultiLevelSelectLegacyButton = function (props) {
    var disabled = props.disabled, _a = props.look, look = _a === void 0 ? "tertiary" : _a, _b = props.children, children = _b === void 0 ? "Add filter" : _b, forwardProps = __rest(props, ["disabled", "look", "children"]);
    var size = useSelectableContext().size;
    var isOpen = useDropdownContext().isOpen;
    return (jsx(DropdownButton, __assign({ "aria-expanded": isOpen, look: look, size: size, disabled: disabled }, forwardProps, { children: children })));
};
MultiLevelSelectLegacyButton.displayName = "MultiLevelSelectLegacyButton";

export { MultiLevelSelectLegacyButton };
//# sourceMappingURL=MultiLevelSelectLegacyButton.js.map
